const getThresholdValueFlu = (level) => {
  switch (level) {
    case 1:
      return {
        threshold: 'Minimal',
        color: '#007000',
        OutlineColor: '#007000',
      }
    case 2:
      return {
        threshold: 'Minimal',
        color: '#21851C',
        OutlineColor: '#21851C',
      }
    case 3:
      return {
        threshold: 'Minimal',
        color: '#3C9A34',
        OutlineColor: '#3C9A34',
      }

    case 4:
      return {
        threshold: 'Low',
        color: '#57AF4F',
        OutlineColor: '#21851C',
      }
    case 5:
      return {
        threshold: 'Low',
        color: '#76C36D',
        OutlineColor: '#21851C',
      }
    case 6:
      return {
        threshold: 'Low',
        color: '#99D790',
        OutlineColor: '#3C9A34',
      }


    case 7:
      return {
        threshold: 'Moderate',
        color: '#C0E8BB',
        OutlineColor: '#3C9A34',
      }
    case 8:
      return {
        threshold: 'Moderate',
        color: '#FFFFF0',
        OutlineColor: '#AD8D01',
      }
    case 9:
      return {
        threshold: 'Moderate',
        color: '#FFD7B3',
        OutlineColor: '#DC5E22',
      }

    case 10:
      return {
        threshold: 'High',
        color: '#FFA977',
        OutlineColor: '#DC5E22',
      }
    case 11:
      return {
        threshold: 'High',
        color: '#FC7261',
        OutlineColor: '#C40000',
      }
    case 12:
      return {
        threshold: 'High',
        color: '#F03028',
        OutlineColor: '#F03028',
      }

    case 13:
      return {
        threshold: 'Very High',
        color: '#C40000',
        OutlineColor: '#C40000',
      }
    case 14:
      return {
        threshold: 'Very High',
        color: '#941E63',
        OutlineColor: '#941E63',
      }
    case 15:
      return {
        threshold: 'Very High',
        color: '#6F0A46',
        OutlineColor: '#6F0A46',
      }


    default:
      return {
        threshold: 'No Data',
        color: '#E5E5E6',
        OutlineColor: '#7D7F81',
      }
  }
}

export default getThresholdValueFlu